import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { PlaceModel } from '@app/core/models';
import {
  IPlaceApiV5Model,
  IPlaceGetRequest,
  IPlaceListGetRequest,
} from '@app/core/models/api';

@Injectable()
export class PlaceApiService {
  constructor(private http: HttpClient) {}

  getAllPlaces(
    clusterId?: number,
    search?: string,
  ): Observable<Array<PlaceModel>> {
    let req: IPlaceListGetRequest = {};

    if (clusterId != null) {
      req.cluster_id = clusterId;
    }

    if (search != null) {
      req.search = search;
    }

    return this.getPlaceList(req, true);
  }

  getPlacesByCluster(clusterId: number): Observable<Array<PlaceModel>> {
    const req: IPlaceListGetRequest = {};

    if (clusterId != null) {
      req.cluster_id = clusterId;
    }

    return this.getPlaceList(req, true);
  }

  getPlacesByCategory(
    clusterId: number,
    category: number,
  ): Observable<Array<PlaceModel>> {
    return this.getPlaceList(
      {
        cluster_id: clusterId,
        curated_category_id: category,
      },
      true,
    );
  }

  getAllPins(
    clusterId?: number,
    search?: string,
  ): Observable<Array<PlaceModel>> {
    const req: IPlaceListGetRequest = {};

    if (clusterId != null) {
      req.cluster_id = clusterId;
    }

    if (search != null) {
      req.search = search;
    }
    return this.getPlaceList(req);
  }

  getPlace(req: IPlaceGetRequest): Observable<PlaceModel> {
    return this.http
      .get<IPlaceApiV5Model>(`${environment.API_URL}v5/place.json`, {
        params: new HttpParams({ fromObject: req as any }),
      })
      .pipe(map(data => new PlaceModel(data)));
  }

  private getPlaceList(
    req: IPlaceListGetRequest,
    isFullOutput: boolean = false,
  ): Observable<Array<PlaceModel>> {
    if (isFullOutput) {
      req.output_fields = ['contact_info', 'images', 'categories_curated'].join(
        ',',
      );
    }
    // 'events',
    // 'action_buttons',
    return this.http
      .get<Array<IPlaceApiV5Model>>(`${environment.API_URL}v5/places.json`, {
        params: new HttpParams({ fromObject: req as any }),
      })
      .pipe(map(data => data.map(item => new PlaceModel(item))));
  }
}
